export default "__VITE_ASSET__DUVDSDfj__"